import { PropsWithChildren } from 'react';
import { Element, Frame, useEditor } from '@craftjs/core';
import { theme } from '@frontend/theme';
import { mergeClasses } from '@frontend/design-system';
import { COMPOSER_BREAKPOINTS } from '../constants';
import { Designer } from './designer';
import { LocationPicker } from './location-picker';
import { Sidebar } from './sidebar';

export const SUBJECT_FIELD_NAME = 'subject';

type Props = PropsWithChildren & {
  className?: string;
  emptyStateSubTitle: string;
  emptyStateTitle: string;
};

export const ContentComposerBody = ({ children, className, emptyStateTitle, emptyStateSubTitle }: Props) => {
  const {
    actions: { clearEvents },
    query: { getEvent },
  } = useEditor();

  const deselectAllSections = () => {
    const isAnyEventsAvailable =
      !getEvent('selected').isEmpty() || !getEvent('dragged').isEmpty() || !getEvent('hovered').isEmpty();
    if (isAnyEventsAvailable) {
      clearEvents();
    }
  };

  return (
    <>
      <Sidebar />
      <section
        className={mergeClasses('content-composer-body', className)}
        css={{
          alignItems: 'center',
          background: theme.colors.neutral5,
          boxShadow: 'inset 3px 0 4px -2px rgba(0, 33, 82, 0.15)',
          display: 'flex',
          flexDirection: 'column',
          gridArea: 'main',
          justifyContent: 'center',
          minHeight: 0,
          overflow: 'hidden',
          position: 'relative',

          [`@media (max-width: ${COMPOSER_BREAKPOINTS.DESKTOP}px)`]: {
            boxShadow: 'none',
          },
        }}
        onClick={deselectAllSections}
      >
        {children}
        <Frame>
          <Element canvas emptyStateSubTitle={emptyStateSubTitle} emptyStateTitle={emptyStateTitle} is={Designer} />
        </Frame>
      </section>
    </>
  );
};

ContentComposerBody.LocationPicker = LocationPicker;
